module.exports = __webpack_public_path__ + "media/images/leadership_characteristics/bg-7-779c10379e31611b46881a26720a6c7a.png";